import { Button, Modal, MyIcon } from 'ccs-ui-components';
import { useState } from 'react';
import { Toast } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import FileIcon from '../../../../control-plane/_components/icons/FileIcon';
import UploadIcon from '../../../../control-plane/_components/icons/UploadIcon';
import { IUploadFiles } from '../../../../control-plane/models';
import { PopoverHover } from '../../UI/Popover/PopoverHover';
import classes from './UploadFiles.module.scss';

const UploadFiles = (props: IUploadFiles) => {
  const navigate = useNavigate();

  const { t: translate } = useTranslation();
  const {
    uploadedFilesForJSON,
    getRootJSONProps,
    getInputJSONProps,
    setUploadedFilesForJSON,
    path,
    handleNavigateToImport
  } = props;
  const [showModal, setShowModal] = useState(false);
  /**
   * @method toggleShowAForJSON
   * @description initialise the fileupload state uploadedFilesForJSON when we close the toaster
   * @returns empty array
   */
  const toggleShowAForJSON = () => {
    setUploadedFilesForJSON('');
  };
  const sufixes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  /**
   * @method getBytes
   * @description converts bytes into size with sufixes
   * @params bytes
   * @returns bytes from proper size
   */
  const getBytes = (bytes: number) => {
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (
      (!bytes && '0 Bytes') || `${(bytes / 1024 ** i).toFixed(2)} ${sufixes[i]}`
    );
  };
  /**
   * @method handleNavigateToImport
   * @description navigates to import tab
   * @returns navigated url
   */
  /**
   * @method navigateToJourneys
   * @description navigates to journey list
   * @returns navigated url
   */
  const navigateToJourneys = () => {
    navigate(path);
  };
  /**
   * @method handleCancelFromImport
   * @description handles hide and show of a cancel modal based on files uploaded
   * @returns hide and show of a cancel modal
   */
  const handleCancelFromImport = () => {
    if (uploadedFilesForJSON.length !== 0) {
      setShowModal(true);
    } else {
      navigateToJourneys();
    }
  };
  /**
   * @method closeModal
   * @description closes cancel modal
   * @returns false
   */
  const closeModal = () => {
    setShowModal(false);
  };
  return (
    <div className={classes['drag-and-drop-block']} data-testid="importevent">
      <Modal
        modalTitle={translate('uploadFiles.cancel')}
        modalBody={translate('uploadFiles.confirmationMsg')}
        modalShow={showModal}
        onCloseModal={closeModal}
        onSaveModal={navigateToJourneys}
        btnCloseText={String(translate('uploadFiles.stay'))}
        btnSaveText={String(translate('uploadFiles.leave'))}
        dataTestId="import-journey"
        disableSaveBtn={false}
        disableCloseBtn={false}
        alignToCentre
      />
      <p className={classes['import-label-styles']}>
        <span className={classes['required-styles']}>*</span>{' '}
        {translate('import_journey_configuration_component.txt_import_zip')}
      </p>
      <div
        {...getRootJSONProps()}
        className={
          uploadedFilesForJSON?.length !== 0 && !(uploadedFilesForJSON.name?.replace(/.zip/g, '').includes('.'))
            ? classes['drag-and-drop-container-disabled']
            : classes['drag-and-drop-container']
        }
      >
        <input {...getInputJSONProps()} data-testid="drop-input" />
        <div className={classes['drag-and-drop-image-content-holder']}>
          <UploadIcon />
          <p className={classes['drag-and-drop-text']}>
            {translate(
              'import_journey_configuration_component.txt_drag_and_drop'
            )}
          </p>
          <p className={classes['drag-and-drop-sub-text']}>
            {translate(
              'import_journey_configuration_component.txt_supported_zip_format'
            )}
          </p>
        </div>
      </div>
      {uploadedFilesForJSON.path?.replace(/.zip/g, '').includes('.') && (
        <div className={classes['error-container']}>
          {translate(
            'import_journey_configuration_component.txt_validation'
          )}
        </div>)}

      <Toast
        show={uploadedFilesForJSON.length !== 0 && !(uploadedFilesForJSON.path?.replace(/.zip/g, '').includes('.'))}
        onClose={toggleShowAForJSON}
        key={uploadedFilesForJSON.path}
        className={classes['toaster-container']}
      >
        <Toast.Body className={classes['toast-text-body']}>
          <FileIcon />
          <div className={classes['toast-text-holder']}>
            <PopoverHover
              message={uploadedFilesForJSON.path}
              placement="right"
            >
              <p className={classes['toaster-container-title']}>
                {uploadedFilesForJSON.path}
              </p>
            </PopoverHover>
            <p className={classes['toaster-container-sub-title']}>
              {getBytes(uploadedFilesForJSON.size)}
            </p>
          </div>
          <div
            role="button"
            aria-label="view-btn"
            tabIndex={0}
            onClick={toggleShowAForJSON}
            onKeyDown={toggleShowAForJSON}
            className={classes['drag-and-drop-cancel-image']}
          >
            <MyIcon name="xMarkLargeIcon" />
          </div>
        </Toast.Body>
      </Toast>
      <div className={`${classes['upload-files-buttons-holder']} ci-button-group`}>
        <Button
          variant="secondary"
          className={classes['upload-files-button-secondary']}
          onClick={handleCancelFromImport}
          data-testid="cancel-handlemodal-show-events"
        >
          {translate(
            'import_journey_configuration_component.txt_cancel_button'
          )}
        </Button>
        <Button
          variant="primary"
          disabled={
            uploadedFilesForJSON.length === 0 || uploadedFilesForJSON.name?.replace(/.zip/g, '').includes('.')
          }
          onClick={handleNavigateToImport}
          data-testid="next-handlemodal-show-events"
        >
          {translate('import_journey_configuration_component.txt_next_button')}
        </Button>
      </div>
    </div>
  );
};

export default UploadFiles;
